import { useAppContext } from "../../AppProvider";
import { getCustomDatasHeaderGridLayout } from "./Layout";
import { createcustomDataHeaderGridVars } from "./Layout/gridVars";

export const CustomDataHeader = () => {
  const { dictionary, display } = useAppContext();

  const customDatasLayout = getCustomDatasHeaderGridLayout();
  const customDatasStyle = createcustomDataHeaderGridVars(customDatasLayout);
  return (
    <>
      {(display.lg || display.xl || display.xxl) && (
        <>
          <div
            data-grid-template="customDatasHeader"
            className="d-grid gap-2 px-2 mb-2"
            style={customDatasStyle}
          >
            <div data-grid-area="description">
              <label className="label-2">
                {dictionary.registries.description}
              </label>
            </div>
            <div data-grid-area="unitWeight">
              <label className="label-2">
                {dictionary.dimensions.unit_weight + " (Kg)"}
              </label>
            </div>
            <div data-grid-area="unitPrice">
              <label className="label-2">
                {dictionary.dimensions.unit_value}
              </label>
            </div>
            <div data-grid-area="hsCode">
              <label className="label-2">
                {dictionary.customs_data.hs_code}
              </label>
            </div>
            <div data-grid-area="countryIsoCode2">
              <label className="label-2">
                {dictionary.customs_data.country_of_origin}
              </label>
            </div>
            <div data-grid-area="quantity">
              <label className="label-2">
                {dictionary.registries.quantity}
              </label>
            </div>
          </div>
        </>
      )}
    </>
  );
};
